export const getGoogleIDValue = (value) =>
  value ? `${value.split('.')[2]}.${value.split('.')[3]}` : ''
